export enum CountryCodeEnum {
    DE = 'Deutschland',
    AT = 'Österreich'
}

